document.addEventListener('DOMContentLoaded', function () {
  var variantRadiosElements = document.querySelectorAll('variant-radios');
  if (!variantRadiosElements.length) return;

  variantRadiosElements.forEach(function (variantRadios) {
    var jsonScript = variantRadios.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try {
      variants = JSON.parse(jsonScript.textContent || '[]');
    } catch (e) {
      console.error('Error parsing variants JSON', e);
      return;
    }

    if (!Array.isArray(variants) || !variants.length) return;

    var inventoryScript = variantRadios.querySelector(
      'script[type="application/json"][data-variant-inventory]'
    );
    if (inventoryScript) {
      try {
        var inventoryVariants = JSON.parse(inventoryScript.textContent || '[]');
        if (Array.isArray(inventoryVariants) && inventoryVariants.length) {
          var inventoryById = {};
          inventoryVariants.forEach(function (inventoryVariant) {
            inventoryById[inventoryVariant.id] = inventoryVariant;
          });
          variants = variants.map(function (variant) {
            var inventoryVariant = inventoryById[variant.id];
            if (!inventoryVariant) return variant;
            return Object.assign({}, variant, {
              inventory_management: inventoryVariant.inventory_management,
              inventory_quantity: inventoryVariant.inventory_quantity,
            });
          });
        }
      } catch (inventoryError) {
        console.error('Error parsing variant inventory JSON', inventoryError);
      }
    }

    var sectionId = variantRadios.dataset.section;
    if (!sectionId) return;

    function getCurrentOptions() {
      var fieldsets = Array.prototype.slice.call(
        variantRadios.querySelectorAll('fieldset')
      );

      return fieldsets.map(function (fieldset) {
        var checked = Array.prototype.slice
          .call(fieldset.querySelectorAll('input[type="radio"]'))
          .find(function (radio) {
            return radio.checked;
          });

        return checked ? checked.value : null;
      });
    }

    function findMatchingVariant(options) {
      return variants.find(function (variant) {
        if (!variant.options || !variant.options.length) return false;
        for (var i = 0; i < options.length; i++) {
          if (options[i] === null) return false;
          if (variant.options[i] !== options[i]) return false;
        }
        return true;
      });
    }

    function isLowStock(variant, threshold) {
      if (!variant || !variant.available) return false;
      if (!variant.inventory_management) return false;
      var qty = variant.inventory_quantity;
      if (qty <= 0) return false;
      threshold = parseInt(threshold, 10) || 0;
      if (threshold === 0) return true;
      return qty < threshold;
    }

    function findVariantForOptionValue(optionIndex, optionValue, selectedOptions) {
      var options = selectedOptions.slice();
      options[optionIndex] = optionValue;

      var matchedVariant = variants.find(function (variant) {
        if (!variant.options || !variant.options.length) return false;
        for (var i = 0; i < variant.options.length; i++) {
          if (i === optionIndex) {
            if (variant.options[i] !== optionValue) return false;
          } else if (options[i] !== null && options[i] !== undefined) {
            if (variant.options[i] !== options[i]) return false;
          }
        }
        return true;
      });

      if (matchedVariant) return matchedVariant;

      return variants.find(function (variant) {
        return variant.options && variant.options[optionIndex] === optionValue;
      });
    }

    function updateLowStockDots() {
      var threshold = variantRadios.dataset.inventoryThreshold;
      if (threshold === undefined) return;

      var fieldsets = Array.prototype.slice.call(
        variantRadios.querySelectorAll('fieldset')
      );
      var selectedOptions = getCurrentOptions();

      fieldsets.forEach(function (fieldset, optionIndex) {
        var radios = fieldset.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(radios, function (radio) {
          var label = fieldset.querySelector('label[for="' + radio.id + '"]');
          if (!label) return;

          var variant = findVariantForOptionValue(
            optionIndex,
            radio.value,
            selectedOptions
          );
          var dot = label.querySelector('.variant-low-stock-dot');

          if (isLowStock(variant, threshold)) {
            if (!dot) {
              dot = document.createElement('span');
              dot.className = 'variant-low-stock-dot';
              dot.setAttribute('aria-hidden', 'true');
              label.appendChild(dot);
            }
          } else if (dot) {
            dot.remove();
          }
        });
      });
    }

    function updateInventoryFromServer() {
      var options = getCurrentOptions();
      var variant = findMatchingVariant(options);
      if (!variant) return;

      var sectionParam =
        variantRadios.dataset.originalSection || variantRadios.dataset.section;

      if (!variantRadios.dataset.url || !sectionParam) return;

      var url =
        variantRadios.dataset.url +
        '?variant=' +
        encodeURIComponent(variant.id) +
        '&section_id=' +
        encodeURIComponent(sectionParam);

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var doc = new DOMParser().parseFromString(responseText, 'text/html');

          // Inventory block
          var newInventory = doc.querySelector('.ru-inventory__wrapper');
          var inventorySlot = document.querySelector(
            '[data-inventory-slot][data-section="' + sectionId + '"]'
          );
          var currentInventory = inventorySlot
            ? inventorySlot.querySelector('.ru-inventory__wrapper')
            : document.querySelector(
                '.ru-inventory__wrapper[data-section="' + sectionId + '"]'
              );

          if (inventorySlot) {
            if (newInventory) {
              newInventory.setAttribute('data-section', sectionId);
              if (currentInventory) {
                currentInventory.replaceWith(newInventory);
              } else {
                inventorySlot.insertBefore(newInventory, inventorySlot.firstChild);
              }
            } else if (currentInventory) {
              currentInventory.remove();
            }
          } else if (currentInventory) {
            if (!newInventory) {
              currentInventory.remove();
            } else {
              newInventory.setAttribute('data-section', sectionId);
              currentInventory.replaceWith(newInventory);
            }
          }

          // Free shipping info block
          var newFreeShipping = doc.querySelector('.ProductMeta__FreeShippingInfo');
          var currentFreeShipping = document.querySelector(
            '.ProductMeta__FreeShippingInfo[data-section="' + sectionId + '"]'
          );

          if (currentFreeShipping) {
            if (!newFreeShipping) {
              currentFreeShipping.style.display = 'none';
            } else {
              newFreeShipping.setAttribute('data-section', sectionId);
              currentFreeShipping.replaceWith(newFreeShipping);
            }
          }
        })
        .catch(function (error) {
          console.error('Error updating inventory from server', error);
        });
    }

    updateLowStockDots();

    variantRadios.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="radio"]')) {
        updateLowStockDots();
        updateInventoryFromServer();
      }
    });
  });
});


